import { StyleSheet, Text, View } from 'react-native';

import Feather from '@expo/vector-icons/Feather';

import { colors } from '../theme';
import { inter400, inter500 } from '../utils/platform';

export type EducationItemProps = {
  degree: string;
  institution: string;
  description: string;
  period?: string;
  location?: string;
};

export function EducationItem({
  location,
  period,
  degree,
  institution,
  description,
}: EducationItemProps) {
  return (
    <View style={styles.card}>
      <View style={styles.title}>
        {location ? <View style={styles.locationRow}>
          <View style={styles.locationGroup}>
            <View style={styles.icon14}>
              <Feather name="map-pin" size={14} color={colors.muted} />
            </View>
            <Text style={styles.metaText}>{location}</Text>
          </View>

          {period ? <Text style={styles.metaText}>{period}</Text> : null}
        </View> : null}

        <Text style={styles.degree}>{degree}</Text>
        <Text style={styles.metaText}>{institution}</Text>
      </View>

      <Text style={styles.paragraph}>{description}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    borderColor: colors.border,
    borderLeftWidth: 1,
    gap: 32,
    overflow: 'hidden',
    paddingLeft: 16,
    width: '100%',
  },
  title: {
    gap: 8,
    overflow: 'hidden',
    width: '100%',
  },
  locationRow: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: 10,
    overflow: 'hidden',
    width: '100%',
  },
  locationGroup: {
    alignItems: 'center',
    flex: 1,
    flexDirection: 'row',
    gap: 6,
    overflow: 'hidden',
  },
  icon14: {
    height: 14,
    width: 14,
  },
  metaText: {
    color: colors.muted,
    fontFamily: inter400,
    fontSize: 14,
    fontWeight: '400',
    lineHeight: 19.6,
  },
  degree: {
    color: colors.text,
    fontFamily: inter500,
    fontSize: 16,
    fontWeight: '500',
    lineHeight: 19.2,
  },
  paragraph: {
    color: colors.muted,
    fontFamily: inter400,
    fontSize: 16,
    fontWeight: '400',
    lineHeight: 22.4,
  },
});
